import { Fragment } from "react";
import { Box, Typography } from "@mui/material";
import CAccordionItem from "./CAccordionItem";
import { Section } from "typedef/ResponseGladly";
import color from "context/MaterialUITheme/color";

export default function CAccordion({
  last,
  header,
  answerIds,
}: Section & { last?: boolean }) {
  return (
    <Fragment>
      <Box mt={2} mb={1}>
        <Typography variant="h4" color={color.black}>
          {header}
        </Typography>
      </Box>
      {answerIds?.map((answerId: string) => (
        <CAccordionItem answerId={answerId} key={answerId} last={last} />
      ))}
    </Fragment>
  );
}
